/**
 * This is the reserved color to mark the part in the texture that is variable
 */
export const VARIABLE_TEXTURE_COLOR = "#ff00ff";
export const VARIABLE_TEXTURE_SECONDARY_COLOR = "#00ffff";
